// extracted by mini-css-extract-plugin
export default {"container":"SignInNotificationBanner__container--ZdL","link":"SignInNotificationBanner__link--1qA"};